import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MessageHandler from '../../util/luciPanelMessageHandler';
import MessageType from '../../constants/luciPanelMessageTypes';

const IFrameContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: ${props => props.width};
`;

const LUCI_PANEL_API_VERSION = '1.0';

class LuciPanel extends React.Component {
  componentDidMount() {
    this.props.onRef(this);
    this.messageHandler = new MessageHandler(this.iFrame.contentWindow);
    this.messageHandler.setOnDataPanelLoadCallBack(this.props.onDataPanelLoad);
    this.messageHandler.setOnDataPanelUpdateCallBack(this.props.onDataPanelUpdate);
    this.messageHandler.setOnDataPanelSelectImageCallBack(this.props.onSelectImageRequest);
    console.log('Luci panel message handler initialized');
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
    if (this.messageHandler) {
      this.messageHandler.destroy();
    }
  }

  sendLoadResponseToPanel = (data) => {
    this.sendLoadResponseToPanel(data, MessageType.DATAPANEL.LOAD.RESPONSE);
  }

  sendMessage = (data, type) => {
    if (!type) {
      console.log(`Invalid message being sent to panel: ${type}`);
      return;
    }

    this.messageHandler.sendMessageToPanel(
      MessageHandler.createMessage(
        LUCI_PANEL_API_VERSION,
        type,
        data
      )
    );
  }

  render() {
    const { height, src, width } = this.props;
    return (
      <IFrameContainer width={width}>
        <iframe ref={(ref) => (this.iFrame = ref)} src={src} height={height} width={width} frameBorder="0" />
      </IFrameContainer>
    );
  }
}

LuciPanel.defaultProps = {
  onRef: () => {},
  height: '300px',
  width: '800px',
  onSelectImageRequest: () => {},
  onDataPanelLoad: () => {},
  onDataPanelUpdate: () => {}
};

LuciPanel.propTypes = {
  onRef: PropTypes.func,
  height: PropTypes.string,
  src: PropTypes.string.isRequired,
  width: PropTypes.string,
  onSelectImageRequest: PropTypes.func,
  onDataPanelLoad: PropTypes.func,
  onDataPanelUpdate: PropTypes.func
};

export default LuciPanel;



// WEBPACK FOOTER //
// ./app/components/Editor/LuciPanel.js